module.exports = __webpack_public_path__ + "img/hr-branch-particle-21.16ef16fc.png";